import { render, staticRenderFns } from "./updateReformCatalog.vue?vue&type=template&id=6d1cdfd8"
import script from "./updateReformCatalog.vue?vue&type=script&lang=js"
export * from "./updateReformCatalog.vue?vue&type=script&lang=js"
import style0 from "./updateReformCatalog.vue?vue&type=style&index=0&id=6d1cdfd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports